export default {
  close: "Хаах",
  cancel: "Цуцлах",
  update: "Хадгалах",
  upload_image: "Зураг оруулах",
  back: "Буцах",
  warning: "Анхаар",
  issue: "Нийтлэл",
  recipient:"Хүлээн авагч",
  issues:"Нийтлэлүүд",
  general: "Ерөнхий",
  total:"Нийт",
  Nothinghere: "Юу ч алга даа найз",
  empty: "Хоосон байна.",
  Revenue:"Орлого",
  background:"Дэвсгэр зураг",
  manager: "Ажилтан",
  analytic: "Аналитик",
  input:"Оруулах",
  promotion: "Урамшуулал",
  magazine:"Сэтгүүл",
  subscription:"Худалдаа",
  ip:"IP хаяг",
  adscontent:"сурталчилгаа",
  choose:"Сонгох",
  wifi:"Утасгүй сүлжээ",
  banners:"Баннэр",
  logo:"Лого",
  name:"Нэр",
  userName:"Нэр",
  your_name: "Таны нэр",
  email: "Цахим шуудан",
  phone: "Утас",
  unknown: "Тодорхойгүй",
  all: "Бүгд",
  mobile_operator: "Оператор",
  age: "Нас",
  browser: "Веб хөтөч",
  catalog: "Сан",
  other: "Бусад",
  organization:"Албан байгууллага",
  person:"Хувь хүн",
  revenue: "Орлогo",
  settings: "Тохиргоо",
  mass_mail: "Mасс Mэйл",
  reset:"Дахин тохируулах",
  pages:"Хуудас",
  detail:"Дэлгэрэнгүй",
  changeLanguage:"Хэл солих",
  change:"Солих",
  revoke:"Устгах",
  edit:"Засах",
  tools:"Хэрэгсэл",
  cacheClear:"Санах ой цэвэрлэх",
  clear:"Цэвэрлэх",
  view:"Үзэлт",
  select:"Сонгох",
  conSocialAcc:"Холбогдсон нийтийн сүлжээ",
  undisIncome:"Олгоогүй олголт",
  completeAccess:"Нэмэлт хандалт",
  auth: {
    logout: "Гарах",
    confirm: "Та гарахдаа итгэлтэй байна уу?"
  },
  ads:{
    ads:"Сурталчилгаа",
    adsview:"Сурталчилгааны үзэлт"
  },
  subscriptions:{
    orders:"Нэхэмжлэх",
    subscriptions:"Захиалга",
    activations:"Идэвхжүүлэлт",
    plan:"Төлбөрийн төрөл",

  },

  account:{
    add:"Бүртгэл нэмэх",
  },

  verification: {
    _name: "Төлөв",
    verified: "Баталгаажсан",
    unverified: "Баталгаажаагүй",
    verify_account: "Бүртгэл баталгаажуулах",
    mail_sent:
      "Таны `{email}` и-мэйл хаягт баталгаажуулах холбоос илгээсэн. Та и-мэйл хаягаа шалгана уу.",
    resend: "Дахин илгээх",
    check_email: "Та и-мэйл хаягаа шалгаад баталгаажуулах товч дээр дарна уу.",
    done: "Таны бүртгэл амжилттай баталгаажлаа."
  },
  dropdown:{
    filters:"Шүүлтүүр",
    salesFilter:"Борлуулалт Шүүлтүүр",
    stateFilter:"Нөхцөлөөр ялгах",
    category:"Төрөл",
    language:"Хэл",
    country:"Улс",
  },
  profile: {
    title: "Бүртгэл",
    my_title: "Миний бүртгэл",
    settings_desc: "Таны аппликейшнд бүртгэлтэй хэрэглэгчийн мэдээлэл.",
    update_avatar: "Зуриг солих",
    avatar_updated: "Таны зураг солигдсон.",
    edit_name: "Нэр солих",
    edit_phone: "Утасны дугаар солих",
    edit_password: "Нууц үг солих",
    updated: "Таны бүртгэлийн мэдээлэл шинэчлэгдсэн."
  },

  password: {
    new: "Шинэ нууц үг",
    confirm: "Нууц үг баталгаажуулалт",
    hint: "Багадаа 6-н тэмдэгтийн урттай байна."
  },

  admin_panel: {
    title: "Удирдлагын хэсэг",
    desc:
      "Та {app} хөгжүүлэгч багийн гишүүн байна. Дэлгэрэнгүй дарж удирдлагын хэсэг рүү шилжих боломжтой."
  },

  publisher_panel: {
    desc:
      "Та дараахь {app} нийлүүлэгчийн эрхийг эзэмшиж байна. Дэлгэрэнгүй дарж удирдлагын хэсэг рүү шилжих боломжтой.",

  },

  library: {
    title: "Миний сан",

  },

  magazines:{
    magazines:"Сэтгүүлүүд",
    issues:"Дугаар",
    categories:"Төрөл",
    feeds:"Нийтлэл",
    add: "Сэтгүүл нэмэх",
    income: "Сэтгүүлийн орлого",
    revenue: "Орлогын тайлан",
  },
  publication: {
    _name: "Бүтээл",
    published: "Нийтлэгч",
    type: {
      magazine: "Сэтгүүл",
      book: "Ном",
      audio_book: "Сонсдог ном",
      podcast: "Подкаст"
    },
    interests: "Бүтээл сонирхосон",
    opens: "Бүтээл нээж үзсэн"
  },

  devices: {
    title: "Төхөөрөмж",
    empty: "Таньд бүртгэлтэй төхөөрөмж байхгүй байна."
  },

  device: {
    _name: "Төхөөрөмж",
    manufacturer: "Үйлдвэрлэгч",
    model: "Загвар",
    registered_on: "Бүртгүүлсэн огноо",
    last_used_date: "Сүүлд ашигласан",
    version: "Төхөөрөмжийн хувилбар",
    OS: "Үйлдлийн систем",
    Socials: "Олон нийтийн суваг",
    usage:"Хэрэглээ",
  },

  purchases: {
    title: "Худалдан авалт",
    empty: "Одоогоор худалдан авалт хийгээгүй байна."
  },

  price: {
    with_curr: "Үнэ ({curr})"
  },

  support_tickets: {
    title: "Тусламж"
  },

  support_ticket: {
    _name: "Тусламж",
    new: "Шинэ хүсэлт",
    title: "Гарчиг",
    desc: "Хүсэлтийн дэлгэрэнгүй",
    file: "Хавсралт",
    auto: "Автомат",
    status: {
      _name: "Төлөв",
      open: "Нээлттэй",
      closed: "Хаагдсан",
      published:"Нийтлэгдсэн",
      unpublished:"Нийтлэгдээгүй",
      draft:"Ноорог",
      check:"Шалгаж байна"
    },
    user_type: {
      customer: "Үйлчлүүлэгч",
      officer: "Тусламжийн амжилтан"
    },
    send: "Хүсэлт илгээх",
    sent: "Таний хүсэлт илгээгдсэн.",
    reply: "Хариу",
    last_reply: "Сүүлд",
    send_reply: "Хариу илгээх",
    compose_reply: "Хариу бичих"
  },

  user: {
    _name: "Хэрэглэгч",
    all: "Бүгд",
    active: "Идэвхтэй",
    preregistered: "Урьдчилж бүртгүүлсэн",
    new: "Шинэ хэрэглэгч",
    bycountry:"Төхөөрөмж улсаар",
    currentActiveUser: "Одоогоор идэвхтэй хэрэглэгч",
    inactiveUser: "Идэвхгүй хэрэглэгч",
    newUser: "Шинэ хэрэглэгч",
    purchasedUser: "Худалдан авалт хийсэн хэрэглэгч",
    role:"Эрх",
  },

  publisher: {
    _name: "Нийтлэгч",
    approvals: "Нийтлэгчийн хүсэлт",
    register: "Бүтээл нийтлэх",
    add: "Нийтлэгч нэмэх"
  },

  author: {
    _name: "Зохиолч"
  },
  promotions:{
    promo: "Урамшуулал",
    campaign: "Aян"
  },
  download: {
    verb:"Татах",
    _name: "Таталт",
    total: "Нийт таталт",
    view: "Уншилт",
    report:{
      title:"Таталтын тайлан",
      vReport:"Уншилтын тайлан"
    },
  },

  lyticView:{
    title:"Аналитик / Ерөнхий / Тойм",
    read: "Хуудасны уншилт",
  },

  report: {
    title: "Тайлан"
  },

  dashboard: {
    app: {
      title: "Хянах самбар"
    },

    web: {
      title: "Веб хандалт",
      guests_and_views: "Зочид ба хуудас үзэлт",
      most_visited_pages: "Хамгийн их үзсэн хуудас",
      external_links: "Гадаад холбоос",
      external_links_desc: "Бусад сайт дээрх холбоосоор дамжин орж ирсэн"
    }
  },
  review:{
    title: "Хянах бүртгэлүүд",
  },
  analytics:{
    title: "Ерөнхий/Tойм",
    aissue: "Аналитик / Дугаар",
    purchase_data: "Хэрэглэгчийн Аналитик"
  },

  dater:{
    l15:"Сүүлийн 15 хоног",
    today:"Өнөөдөр",
    yesterday:"Өчигдөр",
    thisweek:"Энэ долоо хоног",
    lastweek:"Өнгөрсөн долоо хоног",
    thismonth:"Энэ сар",
    lastmonth:"Өнгөрсөн сар",
    thisyear:"Энэ жил",
    lastyear:"Өнгөрсөн жил",
    custom:"Дурын",
    range:"Хугацаагаар шүүх",
    latest:"Гарсан огноо",
    updated:"Шинэчилсэн",
    created:"Үүсгэсэн огноо",
    start:"Эхлэх огноо",
    end:"Дуусах огноо",
    registered:"Бүртгүүлсэн огноо",
    date:"Он сар",
    published: "Нийтлэсэн огноо",
  },

  selling: {
    _name: "Худалдаа",
    sales: "Борлуулалт",
    revenue: "Орлого"
  },

  date: {
    _name: "Огноо",
    range: "Харах мөчлөг",
    period: {
      today: "Өнөөдөр",
      this_week: "Энэ долоо хоногт"
    }
  },
  userDevice:{
    title:"Шинэ хэрэглэгч болон төхөөрөмж"
  },
  downloadOpen: {
    title: "Таталт болон үзэлт",
    opens: "Yзэлт",
    downloads:"Таталт"
  },
  app_open: {
    _name: "Апп нээсэн"
  },

  frequency: {
    first_time: "Шинэ",
    again: "Хуучин"
  },

  gender: {
    _name: "Хүйс",
    male: "Эрэгтэй",
    female: "Эмэгтэй"
  },
  feedback:{
    title: "Cанал Xүсэлт",
  },
  comment: {
    _name: "Сэтгэгдэл"
  },

  series: {
    _name: "Цуврал"
  },

  like: {
    _name: "Зүрх"
  },

  search: {
    _name: "Хайлт",
    user:"Хэрэглэгч хайх",
    publisher:"Зохиогч хайх",
    publisherMag:"Зохиогч болон сэтгүүл хайх",
    magazine: "Сэтгүүл хайх",
    issue: "Нийтлэл хайх",
    search:"Xайх",
    device:"Төхөөрөмж хайх",
    comments:"Сэтгэгдэл хайх",
    last:"Сүүлийн хайлт",
    mostKeyword:"Их ашиглагдсан түлхүүр үг",
    useKeyword:"Түлхүүр үг",
    usedCount:"Ашиглагдсан тоо",
    result:"Илэрцийн тоо",
  },
  pay:{
    all:"Бүгд",
    paid:"Төлөгдсөн",
    unpaid:"Төлөгдөөгүй",
    cancel:"Цуцлагдсан",
    test:"Тест",
    balance:"Төлсөн дүн"
  },
  generate:{
    report:"Тайлан тооцоолох",
  },
  most:{
    read:"Хамгийн их уншсан сэтгүүл",
    issue:"Хамгийн их хандсан Нийтлэл",
    page:"Хамгийн их хандсан хуудас",
    article:"Хамгийн их уншсан үнэгүй өгүүлэл",
    view:"Хамгийн их үзэлттэй Нийтлэл",
    download:"Хамгийн их татагдсан Нийтлэл"
  },
  add:{
    issue:"Нийтлэл нэмэх",
    collection:"Цуглуулга нэмэх",
    access:"Хандалт нэмэх",
    adsPage:"Сурталчилгааны хуудас нэмэх",
    addWifi:"Утасгүй сүлжээ нэмэх",
    user:"Шинэ хэрэглэгч нэмэх",
    banner: "Баннэр нэмэх",
    manager:"Ажилтан нэмэх"
  },
  os: {
    _name: "Үйлдлийн систем",
    version: "ҮС хувилбар",
  },

  guests: {
    total: "Нийт зочид",
    new: "Шинэ зочид",
    returning: "Дахин зочилсон"
  },

  collection: {
    _name: "Цуглуулга"
  },

  invoice: {
    _name: "Нэхэмжлэх"
  },

  income: {
    undistributed: "Олгоогүй олголт",
    distribution: {
      _name: "Олголт"
    }
  },

  marketing: {
    _name: "Маркетинг"
  },

  slider: {
    _name: "Слайдер"
  },

  banner: {
    _name: "Баннэр"
  },

  lottery: {
    _name: "Лотто"
  },

  blog: {
    _name: "Блог"
  },

  notification: {
    _name: "Мэдэгдэл",
    send: "Мэдэгдэл илгээх",
    scheduled:"Захилгат мэдэгдэл",
  },

  logs: {
    _name: "Лог"
  },

  activity_log: {
    _name: "Үйлдлийн бүртгэл"
  },

  unlock: {
    _name: "Authorizations"
  }
};
